import Vue from "vue";
import VueRouter from "vue-router";
// import { Message } from "element-ui";
import store from "../store";

// 引入组件
import Home from "@/views/Home";
import Login from "@/views/Login";
import Carrerpostion from "@/views/Home/carrerpostion";
import Expertteam from "@/views/Home/expertteam";
import Details from "@/views/Home/details";
import Specialentrance from "@/views/Home/specialentrance";
import Studyabroad from "@/views/Home/studyabroad";
import Entrancepath from "@/views/Home/entrancepath";
import Studystatus from "@/views/Home/studystatus";
import Testing from "@/views/Home/testing";
import Measurement from "@/views/Home/measurement";
import Submit from "@/views/Home/submit";
import Report from "@/views/Home/Report";
import Psychology from "@/views/Home/psychology";
import SasAnxiety from "@/components/Reports/SasAnxiety.vue";
import Synthesize from "@/components/Reports/synthesize.vue";
import PsychologyTesting from "@/views/Home/psychologyTesting";
import PsychologyMeasurement from "@/views/Home/psychologyMeasurement";
import StyleAnxiety from "@/components/Reports/StyleAnxiety.vue";
import Questionnaire from "@/views/Home/questionnaire";
import Succeed from "@/views/Home/succeed";
import Logout from "@/views/Home/logout";
Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    {
      path: "/login",
      component: Login,
      meta: {
        isHiddenFooter: true,
      },
    },
    {
      path: "/",
      meta: { title: "学职生涯" },
      component: Home,
      redirect: "/carrerpostion",
      children: [
        {
          path: "carrerpostion",
          component: Carrerpostion,
          meta: { title: "学职定位" },
        },
        {
          path: "expertteam",
          component: Expertteam,
          meta: { title: "专家团队" },
        },
        {
          path: "Details",
          component: Details,
          meta: { title: "学职定位" },
        },
        {
          path: "specialentrance",
          component: Specialentrance,
          meta: { title: "特殊招生" },
        },
        {
          path: "studyabroad",
          component: Studyabroad,
          meta: { title: "留学调研" },
        },
        {
          path: "entrancepath",
          component: Entrancepath,
          meta: { title: "升学路径" },
        },
        {
          path: "studystatus",
          component: Studystatus,
          meta: { title: "学习状态" },
        },
        {
          path: "testing",
          component: Testing,
          meta: { title: "测试说明" },
        },
        {
          path: "measurement",
          component: Measurement,
          meta: { title: "专业定位测评" },
        },
        {
          path: "submit",
          component: Submit,
          meta: { title: "学职定位" },
        },
        {
          path: "psychology",
          component: Psychology,
          meta: { title: "心理测评" },
        },
        {
          path: "report",
          component: Report,
          meta: { title: "我的报告" },
        },
        {
          path: "psychologyTesting",
          component: PsychologyTesting,
          meta: { title: "学职定位" },
        },
        {
          path: "psychologyMeasurement",
          component: PsychologyMeasurement,
          meta: { title: "学职定位" },
        },
        {
          path: "questionnaire",
          component: Questionnaire,
          meta: { title: "出国留学" },
        },
        {
          path: "succeed",
          component: Succeed,
          meta: { title: "出国问卷" },
        },
        {
          path: "logout",
          component: Logout,
          meta: { title: "出国问卷" },
        },
      ],
    },
    {
      path: "/career",
      name: "学职生涯",
      component: StyleAnxiety,
    },
    {
      path: "/styleAnxiety",
      name: "学习风格报告",
      component: StyleAnxiety,
    },
    {
      path: "/sasAnxiety",
      name: "SaS焦虑报告",
      component: SasAnxiety,
    },
    {
      path: "/synthesize",
      name: "学职定位综合报告",
      component: Synthesize,
    },

    {
      path: "/404",
      component: () => import("@/views/404.vue"),
      hidden: true,
    },
    {
      path: "*",
      redirect: "/404",
    },
  ],
  // 每次路由跳转触发函数
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    };
  },
});

// 设置路由导航守卫
/*
  路由导航守卫：当路由跳转的时候触发的狗子函数
    1. 全局盗号守卫(对所有路由生效)
      beforeEach
      beforeResolve
      afterEach
    2. 路由导航守卫(只对当前路由生效)
    3. 组件导航守卫(只对当前组件生效)
*/

// 定义白名单
// const whiteList = ["/login", "/404"];

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = store.state.user.token;
  if (token) {
    // 登录了
    if (to.path === "/login") {
      next("/");
    } else {
      // 登录之后访问其他页面都正常
      next();
    }
  } else {
    // 没有登录不能访问whiteList，要登录在进行访问
    // if (whiteList.includes(to.path)) {
    //   Message.error("请登录在进行访问");
    next();
    // } else {
    //   // sessionStorage.clear();
    //   next("/login");
    // }
  }
});

export default router;
